import { useTableSearchItemStore } from '@aibees/shared/store/table-search-item';
import { Stack } from '@mui/material';
import React, { useEffect, useRef } from 'react';

interface OutsideClickHandlerProps {
  children: React.ReactNode;
}

const OutsideClickHandler: React.FC<OutsideClickHandlerProps> = ({
  children,
}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const { setSelectedItem, selectedItem } = useTableSearchItemStore();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {};

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setSelectedItem, selectedItem]);

  return (
    <Stack ref={wrapperRef} sx={{ height: '100%', width: '100%' }}>
      {children}
    </Stack>
  );
};

export default OutsideClickHandler;
